import {
  Component,
  Input,
  EventEmitter,
  Output
} from '@angular/core';
import { Globals } from '../../../globals';

@Component({
  selector: 'left-nav',
  templateUrl: './left-nav.component.html',
  standalone: false,
})
export class LeftNavComponent {
  @Input() meta;
  @Input() isSecNav;
  @Input() isSidebarPresent;
  @Input() renderer: 'legacy' | 'designtoken' = 'legacy';
  @Output() sidebarEvent = new EventEmitter<any>();
  @Input() sidebarShow = false;
  navReady = false;
  isInitialNavLoad = true;
  constructor(public globals: Globals) {}
  sidebarEventHandler() {
    this.sidebarShow = !this.sidebarShow;
    this.sidebarEvent.emit(this.sidebarShow);
  }

  onNavReady(value: boolean) {
    this.navReady = value;
  }

  isDocPageNav(): boolean {
    if (!this.meta) {
      return false;
    }

    if (this.renderer === 'designtoken') {
      return (
        (this.meta.template === 'app-api-doc' || this.meta.template === 'app-product-landing') &&
        (this.meta['sec-nav'] || this.meta['secondary-nav'])
      );
    }

    return (
      (this.meta.template === 'doc-page' ||
        this.meta.template === 'app-api-doc' ||
        this.meta.template === 'product-landing' ||
        this.meta.template === 'prod-doc-page') &&
      (this.meta['sec-nav'] || this.meta['secondary-nav'])
    );
  }

}
